import { DevTools } from './global/dev-tools.js';
import { LoaderCollection } from './global/loader.js';
   // Initialize the LoaderCollection when the DOM is fully loaded
   document.addEventListener('DOMContentLoaded', () => {
    //console.log('syn-loader')
    window.LoaderCollection = new LoaderCollection([".wpcf7-form"]);
});
jQuery(document).ready(function($) {

   

  

    var modal_controller = {
        class: 'modal',
        active_class: 'active',
        hash_parse: function () {
            var hash = window.location.hash;
            if (hash.length == 0) { 
                return;
            } else {
                var $target = $(hash);
                if (
                    $target.length
                    && $target.hasClass(modal_controller.class)
                ) {
                    jQuery('.'+modal_controller.class).removeClass(modal_controller.active_class);
                    $target.addClass(modal_controller.active_class);
                    jQuery('.modal-container').addClass('active');
                }
            }
        },
        init: function () {
            this.hash_parse();
            $('a[href*="#"]:not([href="#"])').click(function () {
                var target = $(this.hash);

                if (!target.hasClass('modal')) {
                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000);
                        return false;
                    }
                } else {
                    if (!target.hasClass('active')) {
                        target.addClass('active');
                    }
                }
            });
            $('.modal .close-modal').click(function () {
                $(this).closest('.modal').removeClass('active');
                jQuery('.modal-container').removeClass('active');
                history.pushState({}, '', window.location.pathname);
            });
        },
    };

    var mobile_menu = {
        init: function () {
            $('.navbar-toggler').click(function () {
                console.log('clicked');
                var $target = $('#' + $(this).attr('aria-controls'));
                var isExpanded = $target.attr('aria-expanded') === 'true';

                // Toggle the aria-expanded state first
                $target.attr('aria-expanded', !isExpanded);
                
                // Update the icon based on the new state
                if (!isExpanded) {
                    $('.navbar-toggler').find('i').removeClass('icon-bars').addClass('icon-cross');
                    $('.navbar-toggler').addClass('active');
                    $target.slideDown(150);
                } else {
                    $('.navbar-toggler').find('i').removeClass('icon-cross').addClass('icon-bars');
                    $('.navbar-toggler').removeClass('active');
                    $target.slideUp(150);
                }
            });

            $(document).on('click', '.mobile-menu-contain li:not([aria-expanded="true"]) .mobile_expander', function (e) {
                console.log('clickedd');
                e.preventDefault();
                $('.mobile-menu-contain li[aria-expanded="true"]').attr('aria-expanded', 'false').find('.sub-menu').slideUp(200);
                let $parent = $(this).parent();
                $(this).siblings('.sub-menu').slideDown(100, function () {
                    $parent.attr('aria-expanded', 'true');
                });
            });

            $(document).on('click', '.mobile-menu-contain li[aria-expanded="true"] .mobile_expander', function (e) {
                e.preventDefault();
                $(this).parent().attr('aria-expanded', 'false');
                $(this).siblings('.sub-menu').slideUp(100);
            });
        }
    };

    modal_controller.init();
    // mobile_menu.init();


    $('.masked-mailto').on('mouseenter click', function () {
        var $this = $(this);
        var address = $this.data('address');
        var decoded_address = atob(address);
        $this.attr('href', 'mailto:' + decoded_address);
        $this.attr('data-address', '');
        $this.removeClass('masked-mailto');
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const synapse = window.synapse || {};

    // synapse.devTools = new DevTools();

    window.synapse = synapse;
});